module.exports = {
  siteTitle: 'Steven Viar | Software Developer',
  siteDescription: 'Steven Viar is a software developer based in Jacksonville, FL',
  siteKeywords:
    'Steven Viar, Steven, Viar, software developer, front-end, web developer, javascript, react',
  siteUrl: 'https://stevenviar.com',
  siteLanguage: 'en_US',
  googleAnalyticsID: '',
  googleVerification: '',
  name: 'Steven Viar',
  location: 'Jacksonville, FL',
  email: 'steven.viar@gmail.com',
  github: 'https://github.com/stevenviar',
  twitterHandle: '',
  socialMedia: [
    {
      name: 'Github',
      url: 'https://github.com/stevenviar',
    },
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/steven-viar/',
    },
  ],

  navLinks: [
    {
      name: 'About',
      url: '/#about',
    },
    {
      name: 'Experience',
      url: '/#jobs',
    },
    {
      name: 'Projects',
      url: '/#projects',
    },
    {
      name: 'Contact',
      url: '/#contact',
    },
  ],

  navHeight: 100,
  greenColor: '#64ffda',
  navyColor: '#0a192f',
  darkNavyColor: '#020c1b',

  srConfig: (delay = 200) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.25,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
